import React from "react";

function ColorPicker({
  textInputName = "",
  colorInputName = "",
  valueTextInput = "",
  handleChangeColorPicker = undefined,
  handleChangeTextInput = undefined,
  required = undefined,
}) {
  return (
    <div className="color-picker">
      <input
        required={required}
        type="text"
        name={textInputName}
        className="text-input"
        placeholder="#000000"
        value={valueTextInput}
        onChange={handleChangeTextInput}
      />
      <label htmlFor={colorInputName}></label>
      <input
        type="color"
        id={colorInputName}
        name={colorInputName}
        onChange={handleChangeColorPicker}
      />
    </div>
  );
}

export default ColorPicker;
